import logo200Image from '../assets/img/logo/logo_2.png'
import React from 'react'
import { Button, Form, FormGroup, Input, Label, Row, Col, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import Typography from '../components/Typography'
import axios from '../utils/posAxios'
import { MdCameraAlt, MdFace, MdDone, MdClear } from 'react-icons/md'
import Avatar from '../components/Avatar'
import userPlaceholder from '../assets/img/users/profile.jpg'
import StorageService from '../services/StorageService'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { getPayment } from '../utils/dropdownlist'

class PosSupplierForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isEdit: false,
      id: '',
      name: '',
      address: '',
      contact_person: '',
      contact_no: '',
      email: '',
    }
  }

  componentDidMount() {
    if (this.props.data.isEdit) {
      let id = this.props.data.selectedId
      const data = this.props.data.dataList.find(e => e.id === id)
      this.setState({
        isEdit: true,
        id: id,
        name: data.name,
        address: data.address,
        contact_person: data.contact_person,
        contact_no: data.contact_no,
        email: data.email,
      })
    }
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  handleSubmit = event => {
    event.preventDefault()
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    if (!this.state.isEdit) {
      this.create(user, comp, url)
    } else {
      this.edit(user, comp, url)
    }
  }

  create(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      name: this.state.name,
      address: this.state.address,
      contact_person: this.state.contact_person,
      contact_no: this.state.contact_no,
      email: this.state.email,
      created_by: user.email,
    }

    axios
      .post(url + ':3002/v1/product/supplier/add', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.props.closeModal(<MdDone />, 'New supplier added successfully.', 'success', false)
      })
      .catch(error => {
        alert(error)
      })
  }

  edit(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      id: this.state.id,
      name: this.state.name,
      address: this.state.address,
      contact_person: this.state.contact_person,
      contact_no: this.state.contact_no,
      email: this.state.email,
      update_by: user.email,
    }

    axios
      .post(url + ':3002/v1/product/supplier/update', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.props.closeModal(
          <MdDone />,
          'Supplier updated successfully.',
          'success', //'error' post when return error
          false,
        )
      })
      .catch(error => {
        alert(error)
      })
  }

  render() {
    return (
      <Form className="AuthForm" onSubmit={this.handleSubmit}>
        <ModalHeader toggle={this.props.onToggleModal()}>Supplier</ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label>Name</Label>
                <Input type="text" name="name" value={this.state.name} onChange={this.changeHandler} required />
              </FormGroup>
              <FormGroup>
                <Label>Address</Label>
                <Input type="text" name="address" value={this.state.address} onChange={this.changeHandler} />
              </FormGroup>
              <FormGroup>
                <Label>Contact Person</Label>
                <Input type="text" name="contact_person" value={this.state.contact_person} onChange={this.changeHandler} />
              </FormGroup>
              <FormGroup>
                <Label>Contact No</Label>
                <Input type="text" name="contact_no" value={this.state.contact_no} onChange={this.changeHandler} />
              </FormGroup>
              <FormGroup>
                <Label>Email</Label>
                <Input type="email" name="email" value={this.state.email} onChange={this.changeHandler} />
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button className="theme-button theme-button-secondary" onClick={this.props.onToggleModal()}>
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>
        </ModalFooter>
      </Form>
    )
  }
}

export const STATE_ADD = 'ADD'
export const STATE_EDIT = 'EDIT'
export default PosSupplierForm
